import React, { CSSProperties, InputHTMLAttributes, useEffect, useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ReactComponent as NotificationLogo } from '../../styles/img/icons/error.svg';

export interface IInputFieldProps extends InputHTMLAttributes<HTMLInputElement>, WithTranslation {
    fieldContainerClassName?: string;
    fieldName: string;
    fieldTitle: string;
    fieldOptionalText?: string;
    fieldTooltip?: JSX.Element;
    fieldDisabled?: boolean;
    fieldId?: string;
    fieldDisabledPopover?: boolean;
    fieldStyle?: CSSProperties;
    fieldRequired?: boolean;
    handleOnChange?: any;
    fieldInputClass?: string;
    fieldHiddenLabel?: string;
    fieldSelectableLabel?: boolean;
    fieldWeight: number;
}

const InputField = (props: IInputFieldProps) => {
    const {
        t,
        i18n,
        tReady,
        fieldName,
        fieldTitle,
        fieldContainerClassName,
        fieldOptionalText,
        fieldTooltip,
        fieldDisabled,
        fieldId,
        fieldDisabledPopover,
        fieldStyle,
        fieldRequired,
        fieldInputClass,
        handleOnChange,
        fieldWeight,
        fieldHiddenLabel,
        fieldSelectableLabel,
        ...inputProps
    } = props;

    const [inputValue, setInputValue] = useState<any>(inputProps.defaultValue);
    useEffect(() => {
        setInputValue(inputProps.defaultValue);
    }, [inputProps.defaultValue]);

    const inputprops: any = {};
    if (fieldOptionalText) {
        inputprops['aria-label'] = t(fieldTitle).addSpace().concat(t(fieldOptionalText));
    }
    return (
        <div
            id={fieldId}
            className={'field-container '.concat(fieldContainerClassName ?? '')}
            style={fieldStyle}
        >
            <div className={'field-label-container'}>
                <label
                    htmlFor={fieldName}
                    className={'field-label'}
                    tabIndex={fieldSelectableLabel ? 0 : -1}
                    aria-hidden={fieldOptionalText !== undefined}
                >
                    <>
                        {fieldHiddenLabel && fieldDisabled && (
                            <span className="accessibility-hidden">{t(fieldHiddenLabel)}</span>
                        )}
                        {t(fieldTitle)}
                        {fieldOptionalText ? (
                            <span className="field-label--optional field-optional">
                                {''.addSpace() + t(fieldOptionalText)}
                            </span>
                        ) : null}
                    </>
                </label>
                {!fieldDisabledPopover && fieldTooltip}
            </div>
            <input
                {...inputProps}
                name={fieldName}
                id={fieldName}
                readOnly={fieldDisabled}
                className={'field-input field-value '
                    .concat(fieldDisabled ? 'field-input--disabled field-value--disabled ' : '')
                    .concat(fieldInputClass ?? '')}
                defaultValue={inputValue}
                onChange={(e) => {
                    if (e.target.value) {
                        document.getElementById(fieldName)?.classList.remove('registration-error');
                        const errorLogo = document.getElementById(fieldName + '_error_logo');
                        if (errorLogo) {
                            errorLogo.style.display = 'none';
                        }
                    }
                    setInputValue(e.target.value);
                    handleOnChange && handleOnChange(e);
                }}
                data-set-required={fieldRequired}
                data-set-weight={fieldWeight}
                aria-required={fieldRequired}
                aria-disabled={fieldDisabled}
                {...inputprops}
            />
            <NotificationLogo id={fieldName + '_error_logo'} className="field-error-icon" />
        </div>
    );
};

export default withTranslation()(InputField);
